import { getConfig } from './config';
import { logger } from '@common/logging/logger';

export const getConfigEnv = (): 'development' | 'test' | 'production' => {
  const config = getConfig();
  const { env } = config.app;

  switch (env) {
    case 'development':
      return 'development';
    case 'test':
      return 'test';
    case 'production':
      return 'production';
    default:
      logger.error(`Invalid environment value in config: "${env}". Defaulting to 'development'.`);
      // TODO: FDDM: track exception
      return 'development';
  }
};
